const baseUrl = 'https://ewmapi.jy521.cn/api/'
export default {
  // 首页
  Credential: {
    findCredential: baseUrl + 'find-credential',
  },
  
}
